import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { CalendarRange } from 'lucide-react';
import { TrainingRegister } from './TrainingRegister';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/training/training-periods')({
    staticData: {
        metadata: {
            title: 'Training periods',
        },
        ui: {
            icon: CalendarRange,
            title: 'Training periods',
            subtitle: 'Manage training register periods',
            menuDescription: 'Manage training register periods',
        },
    },
    component: TrainingPeriods,
});

function TrainingPeriods() {
    return (
        <PageController route={Route}>
            <TrainingRegister />
        </PageController>
    );
}
